module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER-",
    attrs: {
      "id": "uKzWAnuVgNcKKTLk9l2bxqD",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "urzpCsa7cEZpePfe54YZEMA"
    }
  }), _vm._v("Vincent Dacha")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("Highland")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("“Well, this is a hell of a way to be born!” he muttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Vincent Dacha trudged through the driving snow. He dragged his right foot and held his side. The stasis tank he had been maturing in had crashed to the floor, and fluid from the machine had filled his lungs. In a panic, he’d torn the tubes from his nostrils and the breather from his face. He didn’t know it yet, but he’d been woken early by a small nuclear blast going off underground just a few miles away. He had barely gotten out of his artificial womb alive, and survival didn’t look definite.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Dacha “brothers” came with some information already loaded into them. Vincent knew who he was. He knew "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("what")]), _vm._v(" he was, and he knew that the knowledge and life experiences of all his predecessors would be downloading into him over the next few minutes. He also understood that if he was being born, then another Dacha must have died. Beyond the inherent grief he felt, something else was wrong. His "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("self")]), _vm._v(" felt shaken. There was both too much data coming to him and yet not enough. He could feel the download struggling through a tiny biological modem nestled in his spine. This wasn’t normal. Something was dreadfully wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He looked back to the bunker he’d just stumbled out of. Five-foot snowdrifts collected against the structure, and the door flapped open. He’d considered staying put until someone answered his calls for help, but everything seemed to be in tatters. The small man shook the snow from his too-large shoes and shielded his eyes from the biting wind. His download continued in short bursts. Incomplete and out-of-context information came to him, but he was beginning to make sense of the chaos around him. The machine cloud that typically kept the torrid weather around the Highland facility stable was breaking down. Off in the distance, the cloud wall wavered, lightning flashing up and down its height. “Not good. Not good. Not good!” He shook his head. None of this was what he had expected. Everything was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His body was still hot and adjusting to being out of the tank. Even in the driving snow, he didn’t feel cold, and sweat poured from his brow. Ahead of him, Highland’s landing bay smoldered in the distance. His download continued in fits and starts, and all he knew was that he needed to get to the structure, but he didn’t know why. As he trudged closer, he could see mangled metal stabbing the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He had twisted his ankle while trying to pull on his pants, and the machines that were supposed to feed him his nutrient drink and help him dress for the first time had been damaged by the blast. He was wearing a workman’s uniform he’d found, several sizes too big. He shook his hands free of the long sleeves. “Like I’m wearing daddy’s clothes!” he muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The downloads were coming in more consistently now. A shiver went through him.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("They’re all dead!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He shuddered in panic. He knew that he had been awakened to replace one of his brothers – Ivan, who had died in prison, and he was prepared for that, but all three of them? Ivan, Sergey, and Achilles, all dead? And Highland was falling apart around him, and the machine cloud was deteriorating. A name suddenly came to him, one that came with warm feelings, protection, and an embrace like a motherly vice.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Penny?” he asked aloud, his lips feeling the cold now. “Penny?” he pleaded to the chaos around him.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then he suddenly knew, even Penny was gone. The A.I. that kept this whole place going, that had kept all his selves going, she was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This is a hell of a way to be born!” he said again, this time in anger. This time with the sting of being cheated.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Wreckage and rubble stuck out of the snow outside the landing bay. He found a thin silver sheet of insulation and wrapped it around his shoulders like a shawl, and he made his way through the jagged ruin of the complex. He knew something important was here, but he did not know what. He was being drawn to a specific point, just a few hundred yards away. As he got closer, his sense of mission swelled, guiding him along.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then he saw it, a white stasis pod for a… "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Sabatin")]), _vm._v("? That word came to him, and a cold tingle went down his spine. Nothing good at all downloaded to him about that word – violence, war, greed, conquest. Images displayed in his mind. He saw specs for a fierce bioweapon. It looked like a combination tiger/salamander, covered in silver biological armor. Sensors and implants stuck from its flesh. A mouthful of dagger teeth filled an evil smile.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("With the Sabatin came images he knew were just a few hours old. A horrific battle deep in the control center of Highland – humans and Phaelon mercenaries holding off an attack by waves and waves of giant spiders – an Arnock landing party. His brothers Sergey and Achilles lying dead by their own hand. The flash of an atomic blast. The destruction of the control center. Penny, he "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("felt")]), _vm._v(" her fear as the nuclear fire swept around her. He sensed the destruction dispersing her. It was too much for him.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Stop!” he yelped. He held his head and screamed, desperate for the download to cease. He stomped his feet, and to his surprise, the awful deluge of incoming data did, in fact, stop. He looked to the stasis pod again, to the thing that had triggered so much distress. The pod was propped cockeyed against a twisted I-beam. Atop it, a small light blinked green, indicating it was keeping something alive inside. He somehow knew there wasn’t a Sabatin inside.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He broke into a limping trot, his shoes flapping. He quickly righted the pod, his hands flashing over the controls. On a small screen, it showed there was a person inside, approximately one-hundred-seventy pounds, estimated sixty-one years old. There was no name indicated.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But Vincent Dacha didn’t need a name.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His gut filled with more dread, more so than when he had realized he was alone and his brothers were dead. More so than when he realized that Penny was gone. He turned the handle and the pod cracked open with a hiss. He knew that it was supposed to have a rancid smell, and he shielded his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The first thing he saw was the man’s eye, darting from side to side. A pink membrane was wrapped around him, holding his arms up close to his body. The man’s weight shifted, and the contents of the pod slopped with him onto the ground. Vincent tore the membrane from him as the man took his first breaths and coughed up fluid.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who are you?” the man asked, and then his gaze wandered. “Who am I?” he asked with fraught urgency. “Who am I?” he repeated quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A small amount of relief filled Vincent. He knew who this was. He was an opportunity and maybe a gift. Someone was responsible for the disaster here. Vincent was beginning to think that it was a collective someone. Maybe everyone. He pulled the last of the membrane from the man, using his sleeve to dry his face. This person could be a tool now, someone who could help even the score for all of this, but there was no way in hell Vincent was telling him who he was.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This man couldn’t know that he was Emmanuel Gray.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1055a63e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap_03.vue
// module id = 84
// module chunks = 0